//  PERFECT CODE for all 

let counter = 1;
let file_counter = 1;

const wrapper = document.getElementById('dynamic-fields-wrapper');
const template = document.getElementById('repeated-fields-template');
const dynamicDetailsField = document.getElementById('dynamic-details');

const fileWrapper = document.getElementById('duplicated_file');
const fileTemplate = document.getElementById('repeated__file');

// ------------ Dynamic Textarea/Select Set Handling ------------

function updateDynamicDetails() {
    const allSets = wrapper.querySelectorAll('.cloned-set');
    let result = '';

    allSets.forEach(function (row, index) {
        const selects = row.querySelectorAll('select');
        const textareas = row.querySelectorAll('textarea');

        result += `Set ${index + 1}:\n`;
        selects.forEach(function (select) {
            result += `${select.name}: ${select.value}\n`;
        });
        textareas.forEach(function (ta) {
            result += `${ta.name}: ${ta.value}\n`;
        });
        result += '\n';
    });

    dynamicDetailsField.value = result;
}

document.getElementById('add-field-set').addEventListener('click', function(e) {
    e.preventDefault();

    const newFields = template.cloneNode(true);
    newFields.style.display = 'block';
    newFields.removeAttribute('id');
    newFields.classList.add('cloned-set');

    const inputs = newFields.querySelectorAll('input, select, textarea');
    inputs.forEach(function(input) {
        const newName = input.name.replace(/\d*$/, '') + counter;
        input.name = newName;
    });

    const selects = newFields.querySelectorAll('select');
    const textareas = newFields.querySelectorAll('textarea');

    selects.forEach(select => {
        select.addEventListener('change', updateDynamicDetails);
    });

    textareas.forEach(textarea => {
        textarea.addEventListener('input', updateDynamicDetails);
    });

    const deleteBtn = newFields.querySelector('.remove-field-set');
    deleteBtn.addEventListener('click', function () {
        newFields.remove();
        updateDynamicDetails();
    });

    wrapper.appendChild(newFields);
    counter++;
});
